// Func = limiting Scope for this file
(function () {
	function resizeWindow() {
		setTimeout(function () {
			equalize()
		}, 500)
	}

	// function scrollDown() {
	// 	let top = $(document).scrollTop()
	// 	if (top > 0) {
	// 	} else {
	// 	}
	// }
	let lastScrollTop = 0;
	function scrollDown() {
		//Scroll Down or up for header styles 
		let top = window.pageXOffset || document.documentElement.scrollTop;
		if (top > 0) {
			if(top > lastScrollTop){
				//Scroll Down
				if(!document.getElementById('header').classList.contains('down')) {
					document.getElementById('header').classList.add('down');
					document.getElementById('header').classList.remove('up');
				}
			} else{
				//Scroll Up
				if(!document.getElementById('header').classList.contains('up')){
					document.getElementById('header').classList.add('up');
					document.getElementById('header').classList.remove('down');
				}
			}
		} else {
			if(
				document.getElementById('header').classList.contains('up') ||
				document.getElementById('header').classList.contains('down')
			){
				document.getElementById('header').classList.remove('up');
				document.getElementById('header').classList.remove('down');
			}
		}
		lastScrollTop = top <= 0 ? 0 : top;
	}

	let video = document.getElementById('myVideoPlayer')
	function stopVideo() {
		video.pause()
		video.currentTime = 0
	}

	//animations below
	const animateHTML = function () {
		let elems, windowHeight
		let init = function () {
			elems = document.getElementsByClassName('hide-object')
			windowHeight = window.innerHeight
			addEventHandlers()
		}
		let addEventHandlers = function () {
			window.addEventListener('scroll', checkPosition)
			window.addEventListener('resize', init)
		}
		let checkPosition = function () {
			for (let i = 0; i < elems.length; i++) {
				let posFromTop = elems[i].getBoundingClientRect().top
				if (posFromTop - windowHeight <= 0) {
					elems[i].className = elems[i].className.replace('hide-object', 'show-object')
				}
			}
		}
		return {
			init: init,
		}
	}
	animateHTML().init()
	//end animations

	$(document).ready(function () {
		


		

		//Call function with browser is resized.
		$(window).resize(function (event) {
			resizeWindow()
		})
		resizeWindow()

		//Acts when scroll down page.
		$(window).scroll(function (event) {
			scrollDown()
		})

		//Home page scroll down arrow. If present.
		$('.arrow-home').click(function (event) {
			$('body, html').animate(
				{
					scrollTop: $(window).height() - $('header').outerHeight() * 2,
				},
				1400,
				'easeOutExpo',
			)
			$(this).fadeOut()
		})

		//for Menus
		document.querySelectorAll('.menu-restaurant__tabs li').forEach((btn, i) => {
			btn.addEventListener('click', _ => {
				document.querySelectorAll('.menu-restaurant__tabs li').forEach(b => b.classList.remove('active'));
				btn.classList.add('active');

				document.querySelectorAll('.menu__unitmenu').forEach(room => {
					room.classList.remove('active');
					if ( btn.dataset.tag === 'all' || btn.dataset.tag === room.dataset.tag ) {
						room.classList.add('active');
					}
				});
			});

			if (i === 0) btn.click();
		});

		//Booking
		$('.btn_reserve').click(function () {
			$('#booking-form').addClass('open')
			$('body').addClass('open')
		})
		$('#booking-form .close').click(function () {
			$('#booking-form').removeClass('open')
			$('body').removeClass('open')
		})

		// Main Nav Dropdown
		$('#primary-nav li').hover(
			function () {
				$(this).addClass('hover')
				$('ul.submenu', this).fadeIn(200)
			},
			function () {
				$(this).removeClass('hover')
				$('ul.submenu', this).fadeOut(200)
			},
		)

		//Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
		let DATE_STYLE = [true]
		function calendarRange(date) {
			console.table($('#CheckIn').val(),  DATE_FORMAT);

			let d1 = $.datepicker.parseDate(DATE_FORMAT, $('#CheckIn').val())
			let d2 = $.datepicker.parseDate(DATE_FORMAT, $('#CheckOut').val())

			if ((d1 && date.getTime() == d1.getTime()) || (d2 && date.getTime() == d2.getTime())) {
				DATE_STYLE[1] = 'highlight-top'
			} else if (date > d1 && date < d2) {
				DATE_STYLE[1] = 'highlight'
			} else {
				DATE_STYLE[1] = ''
			}
			return DATE_STYLE
		}

		//Check in and check out datepicker for booking engine
		var hoy = new Date()
		var reopening = new Date(2020, 4, 16)
		var minimumDate = hoy > reopening ? hoy : reopening
		var minDateString = $.datepicker.formatDate('yy-mm-dd', minimumDate)
		$('#CheckIn').val(minDateString)
		const DATE_FORMAT = $('#CheckIn').data('format') !== undefined && $('#CheckIn').data('format') ? $('#CheckIn').data('format') : 'd M yy'
		$('#CheckIn').datepicker({
			changeMonth: true,
			dateFormat: DATE_FORMAT,
			altField: '#check_in_alt',
			altFormat: 'yy-mm-dd',
			numberOfMonths: 1,
			minDate: minimumDate,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function (selectedDate) {
				let getDate = $(this).datepicker('getDate')
				let newDate = new Date(getDate.getTime())
				newDate.setDate(newDate.getDate() + 3)
				$('#CheckOut').datepicker('setDate', newDate)
				$('#CheckOut').datepicker('option', 'minDate', selectedDate)
			},
		})

		var outDay = new Date(minimumDate)
		outDay.setDate(outDay.getDate() + 3)
		var outDayString = $.datepicker.formatDate('yy-mm-dd', outDay)
		$('#CheckOut').val(outDayString)
		$('#CheckOut').datepicker({
			dateFormat: DATE_FORMAT,
			altField: '#check_out_alt',
			altFormat: 'yy-mm-dd',
			changeMonth: true,
			numberOfMonths: 1,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function (selectedDate) {
				//$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
			},
		})

		//Check in and check out datepicker for landing page
		const DATE_FORMAT2 = $('#CheckIn2').data('format') !== undefined && $('#CheckIn2').data('format') ? $('#CheckIn2').data('format') : 'd M yy'
		$('#CheckIn2').datepicker({
			changeMonth: true,
			dateFormat: DATE_FORMAT2,
			altField: '#check_in_alt2',
			altFormat: 'yy-mm-dd',
			numberOfMonths: 1,
			minDate: minimumDate,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function (selectedDate) {
				let getDate = $(this).datepicker('getDate')
				let newDate = new Date(getDate.getTime())
				newDate.setDate(newDate.getDate() + 3)
				$('#CheckOut2').datepicker('setDate', newDate)
				$('#CheckOut2').datepicker('option', 'minDate', selectedDate)
			},
		})
		$('#CheckOut2').datepicker({
			dateFormat: DATE_FORMAT2,
			altField: '#check_out_alt2',
			altFormat: 'yy-mm-dd',
			changeMonth: true,
			numberOfMonths: 1,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function (selectedDate) {
				//$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
			},
		})

		//SLICK SLIDERS
		$('.home-slick').slick({
			arrows: false,
			autoplay: false,
			autoplaySpeed: 4000,
			speed: 500,
			fade: true,
			cssEase: 'linear',
			accessibility: true,
			dots: true,
			slidesToShow: 1,
			slidesToScroll: 1,
		})

		$('.default-slick').slick({
			arrows: false,
			autoplay: true,
			autoplaySpeed: 4000,
			speed: 500,
			fade: true,
			cssEase: 'linear',
			accessibility: true,
			dots: true,
			slidesToShow: 1,
			slidesToScroll: 1,
		})

		//FANCYBOX
		$('.fancybox-copy').fancybox({
			wrapCSS: 'fancybox-copy-holder',
			maxWidth: 800,
		})

		$('.fancybox-image').fancybox({
			wrapCSS: 'fancybox-image-holder',
			//maxWidth: 1044
		})

		//VIDEO FANCYBOX
		$('.video-link').click(function () {
			$('.video-popup').fadeIn()
			$('body').addClass('open')
		})
		$('.video-popup .close-icon').click(function () {
			$('.video-popup').fadeOut()
			$('body').removeClass('open')
			stopVideo()
		})

		//$('ul#privary-navigation li.primary-nav-4 ul.submenu').append('<li class="last_link"><script type="text/javascript" src="https://www.speedrfp.com/irfps/js/widget/"></script>Request Quote</li>');

		// Map: Return to previous page button. Change body id to match map template's name.
		$('body#map #content').prepend('<a class="btn btn-white return-from-map" href="/explore/ada-map">ADA Map</a>')

		// remove attributes for ADA
		$('#third-nav').removeAttr('aria-label')
		$('#third-nav').removeAttr('aria-labelledby')
	})

	
	$(window).load(function () {
		let currentUrl = window.location.href;
		let urlId = currentUrl.includes("#titles-553979");
		let element = document.getElementById('titles-553979');
		function validateUrl(elementToVerify, elementToClick) {
			if (elementToVerify) {
				window.scrollBy(0, -170);
				elementToClick.click();
			}
		}
		validateUrl(urlId, element);
		
		
	});

	$('.fancybox-signup').fancybox();
	
	
})()

/** ADA Submenu Behavior in Main Navigation **/
document.addEventListener('DOMContentLoaded', () => {
		const navItems = document.querySelectorAll('.privary-navigation__item');
	
		navItems.forEach(item => {
		const link = item.querySelector('a[aria-haspopup="true"]');
		const submenu = item.querySelector('.submenu');
	
		if (link && submenu) {
			link.setAttribute('aria-expanded', 'false');
			submenu.setAttribute('aria-hidden', 'true');
	
			const openSubmenu = () => {
			link.setAttribute('aria-expanded', 'true');
			submenu.style.display = 'block';
			submenu.setAttribute('aria-hidden', 'false');
			};
	
			const closeSubmenu = () => {
			link.setAttribute('aria-expanded', 'false');
			submenu.style.display = 'none';
			submenu.setAttribute('aria-hidden', 'true');
			};
	
			link.addEventListener('focus', openSubmenu);

			const focusableElements = submenu.querySelectorAll('.privary-navigation__item a');

			focusableElements.forEach(el => {
			el.setAttribute('tabindex', '0');
			el.addEventListener('focus', openSubmenu);

			});
	
			item.addEventListener('focusout', (e) => {
			setTimeout(() => {
				if (!item.contains(document.activeElement)) {
				closeSubmenu();
				}
			}, 10);
			});
		}
	});
});